import { applyMiddleware, createStore, combineReducers } from 'redux';
import thunkMiddleware from 'redux-thunk';
import createLogger from 'redux-logger';
import { routerReducer } from 'react-router-redux';
import config from 'config';

import * as ReduxLib from '@getgo/webinar.com-frontend-redux/lib/index';
ReduxLib.initialize(config);

// Reducers
import auth from '@getgo/webinar.com-frontend-redux/lib/web/reducers/auth-info';
import identity from '@getgo/webinar.com-frontend-redux/lib/shared/reducers/identity-info';

import contents from '@getgo/webinar.com-frontend-redux/lib/shared/reducers/contents';
import channel from '@getgo/webinar.com-frontend-redux/lib/shared/reducers/channel-profile';

import termsOfService from '@getgo/webinar.com-frontend-redux/lib/shared/reducers/terms-of-service';
import recommendations from '@getgo/webinar.com-frontend-redux/lib/shared/reducers/recommendations';
import userSetting from '@getgo/webinar.com-frontend-redux/lib/shared/reducers/user-setting';
import header from '@getgo/webinar.com-frontend-redux/lib/shared/reducers/header';
import footer from '@getgo/webinar.com-frontend-redux/lib/shared/reducers/footer';
import notification from '@getgo/webinar.com-frontend-redux/lib/shared/reducers/notification';
import homePage from '@getgo/webinar.com-frontend-redux/lib/shared/reducers/home-page';
import content from '@getgo/webinar.com-frontend-redux/lib/shared/reducers/content';
import search from '@getgo/webinar.com-frontend-redux/lib/shared/reducers/search';
import launchDarkly from '@getgo/webinar.com-frontend-redux/lib/web/reducers/launch-darkly';
import attendeeInfo from '@getgo/webinar.com-frontend-redux/lib/shared/reducers/attendee-info';

const middlewares = [thunkMiddleware];

if (config.env !== 'live') {
    const loggerMiddleware = createLogger();
    middlewares.push(loggerMiddleware);
}

const reducers = combineReducers({
    auth,
    identity,
    termsOfService,
    contents,
    channel,
    header,
    footer,
    notification,
    content,
    recommendations,
    userSetting,
    homePage,
    search,
    launchDarkly,
    attendeeInfo,
    routing: routerReducer
});

export default function configureStore(initialState) {
    return createStore(
        reducers,
        initialState,
        applyMiddleware(...middlewares)
    );
}



// WEBPACK FOOTER //
// ./src/Redux/store/configureStore.js